// Combining All Redux Slice Exports

import useEnumerateSlice from "services/redux/reducers/useEnumerateSlice";
import navigationSlice, {
	getAppNavigation,
} from "services/redux/reducers/navigationSlice";
import sideBarSlice, { getLeftSideBar } from "services/redux/reducers/sideBarSlice";
import customerSlice, {
	getCustomerItemsAsDict,
	getCustomerItemsAsList,
} from "services/redux/reducers/customerSlice";
import cartSlice, {
	getCartDrawerShowStatus,
	getCartItemsAsDict,
	getCartItemsAsList,
	getTotalNumberOfCartItems,
} from "services/redux/reducers/cartSlice";
import productSlice, {
	getProductItemsAsDict,
	getProductItemsAsList,
} from "services/redux/reducers/productSlice";
import productCategorySlice, {
	getProductCategoryItemsAsDict,
	getProductCategoryItemsAsList,
	getProductCategoryItemsAsTree,
	getProductCategoriesFilterAsIdList,
	getShowProductsPageProductCategoryDrawer,
} from "services/redux/reducers/productCategorySlice";

import orderSlice, {
	getOrderItemsAsDict,
	getOrderItemsAsList,
	getPagination,
} from "services/redux/reducers/orderSlice";

import serviceRequestSlice, {
	getServiceRequestItemsAsDict,
	getServiceRequestItemsAsList,
	getServiceRequestPagination,
} from "services/redux/reducers/serviceRequestSlice";

import backorderedOrderSlice, {
	getBackorderedOrderItemsAsDict,
	getBackorderedOrderItemsAsList,
	getBackorderedOrderPagination,
} from "services/redux/reducers/backorderedOrderSlice";

import adminProductSlice, {
	getAdminProductItemsAsList,
	getAdminProductItemsAsDict,
} from "services/redux/reducers/adminProductSlice";

import adminCategorySlice, {
	getAdminCategoryItemsAsList,
	getAdminCategoryItemsAsDict,
} from "services/redux/reducers/adminCategorySlice";

// useEnumerate slice
const useEnumerateActions = useEnumerateSlice.actions;
const useEnumerateReducer = useEnumerateSlice.reducer;

// navigation slice
const navigationActions = navigationSlice.actions;
const navigationReducer = navigationSlice.reducer;

// sidebar slice
const sideBarActions = sideBarSlice.actions;
const sideBarReducer = sideBarSlice.reducer;

// customer slice
const customerActions = customerSlice.actions;
const customerReducer = customerSlice.reducer;

// product slice
const productActions = productSlice.actions;
const productReducer = productSlice.reducer;

// product category slice
const productCategoryActions = productCategorySlice.actions;
const productCategoryReducer = productCategorySlice.reducer;

// order slice
const orderActions = orderSlice.actions;
const orderReducer = orderSlice.reducer;

// service request slice
const serviceRequestActions = serviceRequestSlice.actions;
const serviceRequestReducer = serviceRequestSlice.reducer;

// backordered order slice
const backorderedOrderActions = backorderedOrderSlice.actions;
const backorderedOrderReducer = backorderedOrderSlice.reducer;

// admin product slice
const adminProductActions = adminProductSlice.actions;
const adminProductReducer = adminProductSlice.reducer;

// admin category slice
const adminCategoryActions = adminCategorySlice.actions;
const adminCategoryReducer = adminCategorySlice.reducer;

// cart slice
const cartActions = cartSlice.actions;
const cartReducer = cartSlice.reducer;

export {
	useEnumerateSlice,
	useEnumerateActions,
	useEnumerateReducer,
	navigationSlice,
	navigationActions,
	navigationReducer,
	getAppNavigation,
	sideBarSlice,
	sideBarActions,
	sideBarReducer,
	getLeftSideBar,
	customerSlice,
	customerActions,
	customerReducer,
	getCustomerItemsAsDict,
	getCustomerItemsAsList,
	productSlice,
	productActions,
	productReducer,
	getProductItemsAsDict,
	getProductItemsAsList,
	productCategorySlice,
	productCategoryActions,
	productCategoryReducer,
	getProductCategoryItemsAsDict,
	getProductCategoryItemsAsList,
	getProductCategoryItemsAsTree,
	getProductCategoriesFilterAsIdList,
	getShowProductsPageProductCategoryDrawer,
	orderSlice,
	orderActions,
	orderReducer,
	getOrderItemsAsDict,
	getOrderItemsAsList,
	getPagination,
	serviceRequestSlice,
	serviceRequestActions,
	serviceRequestReducer,
	getServiceRequestItemsAsDict,
	getServiceRequestItemsAsList,
	getServiceRequestPagination,
	backorderedOrderSlice,
	backorderedOrderActions,
	backorderedOrderReducer,
	getBackorderedOrderItemsAsDict,
	getBackorderedOrderItemsAsList,
	getBackorderedOrderPagination,
	adminProductSlice,
	adminProductActions,
	adminProductReducer,
	getAdminProductItemsAsList,
	getAdminProductItemsAsDict,
	adminCategorySlice,
	adminCategoryActions,
	adminCategoryReducer,
	getAdminCategoryItemsAsList,
	getAdminCategoryItemsAsDict,
	cartSlice,
	cartActions,
	cartReducer,
	getCartDrawerShowStatus,
	getCartItemsAsDict,
	getCartItemsAsList,
	getTotalNumberOfCartItems,
};
